import { render, staticRenderFns } from "./TableOfParticipants.vue?vue&type=template&id=1ca9573e"
import script from "./TableOfParticipants.vue?vue&type=script&lang=js"
export * from "./TableOfParticipants.vue?vue&type=script&lang=js"
import style0 from "./TableOfParticipants.vue?vue&type=style&index=0&id=1ca9573e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports